import { usePinnedFiltersContext } from '@aibees/elephant/feature/more-filters/context';
import { classnames } from '@aibees/shared/utils';
import { memo, useCallback } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchFiltersInputProps as Props } from './types';

export const SearchFiltersInput = memo(({ className, ...others }: Props) => {
  const { onSearchSearchTableFilters, searchTableSearchTerm } =
    usePinnedFiltersContext();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      onSearchSearchTableFilters?.(newValue);
    },
    [onSearchSearchTableFilters]
  );

  return (
    <Styled.Wrapper
      className={classnames('SearchFiltersInput', className)}
      sx={SX.root}
      size="small"
      placeholder="Search Filters"
      startIcon="search"
      fullWidth
      value={searchTableSearchTerm || ''}
      onChange={handleChange}
      {...others}
    />
  );
});

SearchFiltersInput.displayName = 'SearchFiltersInput';
